// Skill Training Requests

import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import {
  Message,
  ConfirmationService,
  ConfirmEventType,
  MenuItem,
  TreeNode,
  MessageService,
} from 'primeng/api';
import { stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-skill-training-requests',
  templateUrl: './skill-training-requests.component.html',
  styleUrls: ['./skill-training-requests.component.scss'],
  providers: [MessageService],
})
export class SkillTrainingRequestsComponent {
  recreate = false;
  reCreateHolder: any;
  showCustomAlertModal: boolean = false;
  currentAlertTrainingId: string = '';

  filterRequestData!: any;

  page: number = 1;
  rows: number = 10;
  first = 1;
  totalTraining: number = 0;
  allData: any;
  messages: Message[] = [];

  status: any;
  spinner = false;

  allowedRight = [
    'Ministries/Entities',
    'Organisational Units',
    'Branches',
    'Organisational Structure',
  ];
  translator: TranslatorPipe = new TranslatorPipe();

  //Result related variables
  selectCourseForAssessmentResult: any;
  showSelectAssessmentModal: boolean = false;

  //ou
  filteredData: any;
  selectionData: any;
  fieldModal = false;
  fieldData: string = '';
  treeData: any[] = [];
  searchText: string = '';
  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;

  stats: stat[] = [
    { name: this.translate('active'), number: 84, icon: 'pi pi-check-circle' },
    { name: this.translate('Inactive'), number: 2, icon: 'pi pi-times-circle' },
  ];
  ShowDashboard: boolean = false;
  showCalender: boolean = false;

  staticURL = GlobalConstants.staticFilesURL;
  selectedDate: Date = new Date();
  filteredStartDate!: Date;
  filteredEndDate!: Date;
  data: any;
  trainingRequestData!: any[];
  trainingType: any[] = [];
  statusCounts: { [status: string]: number } = {};
  showRevisionModal = false;
  RevisionData: any;
  DateRange: any;
  statusOptions: any[] = [
    // { name: this.translate('pending'), value: 'PENDING' },
    // { name: this.translate('Accepted'), value: 'APPROVED' },
    { name: this.translate('pending'), value: 'TRAINING_CREATED' },
    { name: this.translate('Revision'), value: 'REVISION' },
    // { name: this.translate('Rejected'), value: 'REJECTED' },
    { name: this.translate('Published'), value: 'PUBLISHED' },
    { name: this.translate('completed'), value: 'COMPLETED' },
    { name: this.translate('canceled'), value: 'CANCELED' },
  ];

  publishTo: any = null;
  publishNumberOfAttendees: number = 100;
  numberOfAttendeesOfOu: number = 50;
  publishOus: any = false;
  publishOptions: any[] = [
    { name: this.translate('Self Registration'), key: 'Self Registration' },
    {
      name: this.translate('Manager Registration'),
      key: 'Manager Registration',
    },
    {
      name: this.translate('Self Register Manager Approval'),
      key: 'Self Register Manager Approval',
    },
  ];
  selected = 'New Branch';
  rejectData = {
    _id: null,
    reason: null,
    status: '',
  };
  reasonError: any;
  rejectReason: any;
  requestHolder: any;

  publishModal: boolean = false;
  createCourseModal: boolean = false;
  openCourseModal: boolean = false;
  fromCreateTraining: boolean = false;
  addTrainer: boolean = false;
  trainingDetails: any;
  permissions: any;
  managerOu: any;
  addTrainingProgram = false;

  managerPage: boolean = false;
  coordinatorView: boolean = false;
  openAddKLModal = false;
  selectKLCourse: any;
  coordinatorId: string | undefined;
  skillTypeId: string = '';
  skillTypeName: string = '';
  skillTypeIcon: string = '';
  SelectedCompanyId: string = '';
  companyData: any[] = [];
  trainerView = false;
  isExternalTrainer: boolean = false;
  requestedUser: any = undefined;
  managerLimit: any = undefined;

  isTrainer: any = false;

  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.managerOu = localStorage.getItem('managerOus');
    this.managerOu = this.managerOu ? JSON.parse(this.managerOu) : null;

    //manager SBC MANAGER
    // if (this.managerOu && this.managerOu.length > 0) {
    //   this.managerPage = true;
    //   //this.status = 'TRAINING_CREATED'
    // } else {
    //   // this.statusOptions.push({ name: 'غير نشط ', value: 'DEACTIVATED' });
    // }

    this.ShowDashboard = false;
    if(this.hasPermission('SKILL_TRAINING_DASHBOARD', 'a')){
      this.ShowDashboard = true
    }

    const externalUserString = localStorage.getItem('externalUser');
    if (externalUserString) {
      const externalUser = JSON.parse(externalUserString);
      if (
        externalUser &&
        externalUser.role == 'trainer' &&
        externalUser.status == true
      ) {
        this.isExternalTrainer = true;
        this.isTrainer = true;
      }
      if (externalUser && externalUser.role == 'trainer') {
        this.isTrainer = true;
      }
    }

    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const role = params['role'];
      if (role == 'coordinator') {
        this.coordinatorView = true;
        this.coordinatorId = id;
        this.managerPage = true;
        this.isTrainer = false;
      }
    });
    this.route.params.subscribe((params) => {
      this.skillTypeId = params['typeId'];
      if (this.skillTypeId) {
        Promise.all([
          this.getTrainingRequests(),
          this.getTrainingTypes(),
          this.getCompanyData(),
        ]).then(() => this.getTreeData());
      }
    });

    this.publishTo = this.publishOptions[0];
  }

  getAssessmentSessions(sessions: any[]): any[] {
    return sessions
      ? sessions?.filter((e) => e.sessionType === 'Assessment')
      : [];
  }

  getSurveySessions(sessions: any[]): any[] {
    return sessions ? sessions?.filter((e) => e.sessionType === 'Survey') : [];
  }

  openResults(session: any) {
    let url;
    if (session?.sessionType == 'Survey') {
      url = `/survey/results/${session?.surveyId}?trainingView=true`;
    } else if (session?.sessionType == 'Assessment') {
      url = `/assessment/results/${session?.assessmentId}?trainingView=true`;
    }
    if (url) {
      window.open(
        window.location.protocol + '//' + window.location.host + url,
        '_blank'
      );
    }
  }

  changeRoute(route: any) {
    if (route == '/home') {
      route = '/coordinator-view';
      this.router.navigate([route]);
    } else {
      this.router.navigate([route]);
    }
  }
  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });

    if (res.error) {
      return;
    }
    this.trainingType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        allowed_ou: item.allowed_ou,
        name: item.name,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });

    this.skillTypeName = this.trainingType.find(
      (e: any) => e._id == this.skillTypeId
    ).label;
    this.skillTypeIcon = this.trainingType.find(
      (e: any) => e._id == this.skillTypeId
    ).icon;
    this.selected = this.trainingType.find(
      (e: any) => e._id == this.skillTypeId
    ).name;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  onDateRangeChange() {
    if (this.DateRange && this.DateRange[0] && this.DateRange[1]) {
      this.getTrainingRequests();
    }
  }

  async filter() {
    this.status = undefined;
    await this.getTrainingRequests();

    this.filterByMonth();
    this.status = undefined;
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  refreshFilters() {
    this.status = undefined;
    this.oufilter = undefined;
    this.DateRange = undefined;
    this.getTrainingRequests();
  }

  //   Monthly filter
  filterByMonth() {
    if (this.selectedDate) {
      this.filterRequestData = this.trainingRequestData.filter(
        (record: any) => record.type?.name == 'New Branch'
      );
      this.countStatusOccurrences();
      // this.totalTraining =  this.filterRequestData?.length;
    }
  }

  getCompanyData = async () => {
    try {
      let res = await this.dataService.getData('company/');
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.companyData = res.data;
    } catch (error) {
      console.log(error);
    }
  };

  //get all training requests
  getTrainingRequests = async ($event?:any) => {
    if($event) {
      this.oufilter = $event.node
    }
    try {
      this.statusCounts = {};

      let query: any = { status: this.status, type: this.skillTypeId };

      if (this.DateRange && this.DateRange.length === 2) {
        query.startDate = this.DateRange[0];
        query.endDate = this.DateRange[1];
      }

      if (this.managerPage) {
        query.ous = this.managerOu;
      }

      if (this.hasPermission('SKILL_TRAINING_PUBLISH', 'a')) {
        delete query.ous;
      }

      if (this.oufilter) {
        query.ou = this.oufilter._id;
      }

      if (this.SelectedCompanyId != '') {
        query.creator = this.SelectedCompanyId;
      }

      if (this.status == 'COMPLETED') {
        query.status = 'PUBLISHED';
      }

      if (this.status == 'DEACTIVATED') {
        delete query.status;
        query.active = false;
      }

      let company = '';
      let UserRole = '';
      const externalUserString = localStorage.getItem('externalUser');
      if (externalUserString) {
        const externalUser = JSON.parse(externalUserString);
        if (externalUser && externalUser.company) {
          company = externalUser.company;
        }
        //&& externalUser.status == true
        if (externalUser && externalUser.role) {
          UserRole = externalUser.role;
        }
      }

      if (UserRole == 'trainer') query.trainer = localStorage.getItem('uid');

      if (this.coordinatorView) query.creator = company;

      this.spinner = true;

      this.trainingRequestData = [];

      if (query?.ous?.length <= 0) {
        delete query.ous;
      }

      let res = await this.dataService.postData(
        `training-program/get-merged-training-program-courses?offset=${this.rows}&page=${this.page}`,
        query
      );

      // let res = await this.dataService.postData(`training-req/get-aggregated-v2?offset=${this.rows}&page=${this.page}`, query);

      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      //Check for inactive
      let updatedArray = res?.data?.data.map((obj: any) => {
        if (obj.active == false) {
          return { ...obj, status: 'DEACTIVATED' };
        }
        return obj;
      });

      //Check for completed
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      // Loop through the array and update the status
      updatedArray = updatedArray.map((obj: any) => {
        // Parse the "end_date" from each object
        const endDate = new Date(obj?.trainingId?.end_date);
        // Compare with the current date
        if (endDate < currentDate && obj.status == 'PUBLISHED') {
          // Update the "status" to "COMPLETED"
          return { ...obj, status: 'COMPLETED' };
        }
        return obj; // If the end_date has not passed, return the object as is
      });

      //removing that are not completed
      if (this.status == 'COMPLETED') {
        updatedArray = updatedArray.filter(
          (obj: any) => obj.status == 'COMPLETED'
        );
      }

      this.trainingRequestData = [...updatedArray];

      this.filterRequestData = this.trainingRequestData;
      this.spinner = false;
      this.totalTraining = res?.data?.totalCount;

      // this.filterByMonth();
    } catch (error) {
      console.log(error);
    }
  };

  userQuery: any;

  addAttendees(courseData: any) {
    if (courseData.registrationType == 'Self Register Manager Approval') {
      this.requestedUser = courseData.attendeesRequests;
    } else this.requestedUser = undefined;

    if (
      courseData.registrationType &&
      courseData.registrationType != 'Self Registration'
    ) {
      this.managerLimit = courseData.numberOfAttendeesOfOu;
    } else this.managerLimit = undefined;

    this.usersInCourse = Array.from(
      new Set([
        ...courseData.trainingId.attendees,
        ...courseData.pendingAttendees,
        ...courseData.completedAttendees,
      ])
    );

    this.course = courseData;
    this.addTrainer = true;
  }

  getAllowedOus() {
    return this.course.ous.filter((id: any) => this.managerOu.includes(id));
  }

  usersInCourse: any = [];
  course: any;

  async assNewTrainers(users: any) {
    if (users.emit == false) {
      this.addTrainer = false;
    }

    if (users?.users?.length > this.course?.numberOfAttendeesOfOu) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail:
          this.translate('Total number of users that can be assigned are :') +
          this.course?.numberOfAttendeesOfOu,
      });
      return;
    }

    if (users.emit == true) {
      this.addTrainer = false;
    }

    let data = {
      _id: this.course._id,
      attendees: users.users.map((e: any) => e._id),
    };

    await this.assAttendees(data);
  }

  async assAttendees(data: any) {
    try {
      let res = await this.dataService.postData(
        'course/assign-attendees',
        data,
        'PUT',
        false
      );
      if (!res.error) {
        this.getTrainingRequests();
        return;
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  viewCourse(test: any) {
    console.log(test);
    this.openAddKLModal;
  }

  selectedTreeData: any = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  async getTreeData() {
    let data: any = await this.orgUnits.getOrgUnits();
    this.selectedTreeData = [];

    //get weekly type
    let selectedid: any = this.trainingType.find(
      (e: any) => e._id == this.skillTypeId
    ).allowed_ou;
    // .map((e:any) =>e._id)
    console.log('SELECTED ID', selectedid);

    if (Array.isArray(selectedid)) {
      const promises = selectedid?.map(async (e: any) => {
        if (e.name !== 'الجهات المشاركة') {
          let tempHolder = await this.findNodeByName(data, e);
          this.selectedTreeData.push(cloneDeep(tempHolder));
        }
      });
      // Wait for all promises to resolve before executing the next line
      await Promise.all(promises);
    } else if (typeof selectedid == 'object') {
      if (selectedid.name !== 'الجهات المشاركة') {
        let tempHolder = await this.findNodeByName(data, selectedid);
        this.selectedTreeData.push(cloneDeep(tempHolder));
      }
    }

    //  this.findNodeByName(data, selectedid[0])
    // if (selectedid.label != 'الجهات المشاركة') {

    // this.selectedTreeData.push(this.findNodeByName(data, selectedid._id))

    // this.selectedTreeData.push(this.findNodeByName(data, selectedid._id))

    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
    const uniqueTags = new Set();

    this.types.forEach((type: any) => {
      if (type && type.tag) {
        uniqueTags.add(type.tag);
      }
    });

    let uniqueTagsArray: MenuItem[] = [];

    uniqueTags.forEach((item: any) => {
      if (item != 'Ministries/Entities') uniqueTagsArray.push({ label: item });
    });

    this.selectedTreeTags = uniqueTagsArray;

    this.selectedTreeTags_current = this.selectedTreeTags[0];

    this.changeSelectedTag();
  }

  async findNodeByName(data: any[], nodeName: any): Promise<any | undefined> {
    for (const node of data) {
      if (node._id === nodeName._id) {
        return node;
      }

      if (node.children) {
        const result = await this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }

  async changeSelectedTag() {
    console.log('change tag event', event);
    this.selectedTreeTags_current = {
      label: 'Branches',
    };
    if (this.selectedTreeTags_current.label) {
      this.filterTreeByTag(['Branches', 'Organisational Structure']);
    } else {
      this.selectedTreeData = null;
    }
  }

  filterTreeByTag(tag: string[]) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    console.log('ADDED TREE DATA', this.selectedTreeData);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = [];
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: [],
        });
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string[]): any | null {
    // Recursively filter children nodes

    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (tag.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  openPublishModal(id: any) {
    this.publishModal = true;
    this.rejectData._id = id;
  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map((e) => this.flattenNode(e, result));
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if (node.children) {
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  publish() {
    let ous = this.flattenTree(this.publishOus);

    // Create a Set to store unique IDs
    let uniqueIdsSet = new Set(ous);

    // Convert the Set back to an array
    let uniqueIdsArray = Array.from(uniqueIdsSet);

    let data: any = {
      _id: this.rejectData._id,
      status: 'PUBLISHED',
      ous: uniqueIdsArray,
      registrationType: this.publishTo.key,
      numberOfAttendees: this.publishNumberOfAttendees,
    };

    if (this.publishTo.key != 'Self Registration') {
      data.numberOfAttendeesOfOu = this.numberOfAttendeesOfOu;
    }

    this.confirm({
      message: this.translate(
        'Are you sure you want to pusblish this training'
      ),
      header: this.translate('Comfirm message heading'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.publishTraining(data),
    });
  }

  async publishTraining(data: any) {
    try {
      this.reasonError = undefined;

      let res = await this.dataService.postData(
        'training-req/',
        data,
        'PUT',
        false
      );
      if (!res.error) {
        //reset variables
        this.rejectReason = false;
        this.rejectData = {
          _id: null,
          reason: null,
          status: '',
        };
        this.publishTo = this.publishOptions[0];
        this.publishOus = false;
        this.publishModal = false;
        this.publishNumberOfAttendees = 100;
        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  approve(id: any, status: any = null) {
    // confirm modal lagan h
    this.rejectData._id = id;
    this.rejectData.status = status ? status : 'APPROVED';
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deactivateInit(),
    });
  }

  changeActivation(id: any, status: boolean) {
    // confirm modal lagan h
    this.rejectData._id = id;
    this.rejectData.status = 'APPROVED';
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.activateDeactivate(id, status),
    });
  }

  deleteRequest(id: string) {
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteRequestAPI(id),
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  async deleteRequestAPI(id: string) {
    try {
      let res = await this.dataService.deleteData('course/' + id);
      if (!res.error) {
        this.getTrainingRequests();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async activateDeactivate(id: string, status: boolean) {
    try {
      const data = {
        _id: id,
        active: status,
      };
      let res = await this.dataService.postData(
        'training-req/',
        data,
        'PUT',
        false
      );
      if (!res.error) {
        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async deactivateInit() {
    try {
      if (
        this.rejectData.reason == undefined &&
        this.rejectData.status != 'APPROVED' &&
        this.rejectData.status != 'PUBLISHED' &&
        this.rejectData.status != 'TRAINING_CREATED'
      ) {
        this.reasonError = this.translate('Reason Required');
        return;
      }
      this.reasonError = undefined;
      let res = await this.dataService.postData(
        'training-req/',
        this.rejectData,
        'PUT',
        false
      );
      if (!res.error) {
        this.rejectReason = false;
        this.rejectData = {
          _id: null,
          reason: null,
          status: '',
        };

        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  countStatusOccurrences() {
    this.filterRequestData.forEach((item: any) => {
      const status = item.status;
      if (this.statusCounts[status]) {
        this.statusCounts[status]++;
      } else {
        this.statusCounts[status] = 1;
      }
    });
  }

  async openCourse(req: any, view?: boolean) {
    try {
      let parems: any = !view
        ? {
            _id: req.trainingId._id,
            // flag: view ? 'VIEW' : 'EDIT',
            from: this.managerPage ? 'Manager' : 'SBC',
          }
        : {
            _id: req.trainingId._id,
            flag: 'VIEW',
            // from: this.managerPage ? 'Manager' : 'SBC'
          };

      if (this.isTrainer) parems = { _id: req.trainingId._id };

      this.navigateToTrainingPage(parems);

      // this.createCourseModal = false;
      // this.openCourseModal = true;
      // view ? req.view = true : req.SkillEdit = true;
      // this.permissions = req;
      // let res = await this.dataService.getData('course/' + req._id);
      // if (res.error) {
      //   return
      // }
      // this.trainingDetails = res.data[0]
    } catch (error) {
      console.log(error);
    }
  }

  navigateToTrainingPage(params: any) {
    const trainingId = params._id;
    this.router.navigate(['/training/training-page', trainingId], {
      queryParams: params,
    });
  }

  reCreated(e: any) {
    this.recreate = false;
  }

  onPageChange(event: PageEvent) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1;
    this.getTrainingRequests();
  }

  librarySubmit(event: any) {
    this.openAddKLModal = false;
  }

  // Training Program

  updateHolder: any = undefined;
  selectedProgram: any;

  closeProgramAddFrom(event: any) {
    if (event) {
      this.getTrainingRequests();
    }
    this.addTrainingProgram = false;
  }

  updateTrainingProgram(event: any) {
    this.updateHolder = event;
    this.addTrainingProgram = true;
  }

  getNamesString(data: any): string {
    return data ? data.map((item: any) => item.name).join(', ') : '-';
  }

  //Approve log
  confirmApprove(logData: any) {
    let log: any = {
      _id: logData._id,
      status: 'PUBLISHED',
      courses: logData?.courses.map((e: any) => e.trainingId?._id),
    };
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.ApproveLog(log),
    });
  }

  //API Call Approve
  async ApproveLog(logData: any) {
    try {
      let res = await this.dataService.postData(
        'training-program/',
        logData,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];

      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }

  handleProgram(req: any) {
    if (!!this.selectedProgram && this.selectedProgram._id == req._id)
      this.selectedProgram = undefined;
    else this.selectedProgram = req;
  }


//Approve log
confirmProgramDelete(logData: any) {
  let log: any = {
    _id: logData._id,
  };
  this.confirm({
    message: this.translate('Are you sure you want to do this?'),
    header: this.translate('Confirmation message'),
    icon: 'pi pi-exclamation-triangle',
    action: () => this.deleteProgram(log),
  });
}

async deleteProgram(data:any){
  try {
    let res = await this.dataService.deleteData('training-program/' + data._id);
    if (!res?.error) {
      this.getTrainingRequests();
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
    }
    this.messages = [
      { severity: 'error', summary: this.translate('error') },
    ];

  } catch (error) {
    console.log(error);
  }
}
changeRoute2(route: any, params: string[]) {
  this.router.navigate([route, ...params]);
}

}

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
